var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackToTopArrow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 960) scale(1, -1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M219.499 219.815c-10.604-10.563-27.754-10.521-38.305 0.094s-10.51 27.783 0.094 38.346l318.096 316.877c11.038 10.996 29.043 10.432 39.374-1.233l280.62-316.877c9.924-11.206 8.894-28.343-2.3-38.277s-28.313-8.903-38.236 2.302l-261.586 295.383-297.757-296.616zM81.224 654.662h871.455c10.926 0 19.784-8.857 19.784-19.784s-8.857-19.784-19.784-19.784h-871.455c-10.926 0-19.784 8.857-19.784 19.784s8.857 19.784 19.784 19.784z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackToTopArrow);
export default __webpack_public_path__ + "static/media/back-to-top-arrow.e0bbbff56f809a83fe25758307bbff87.svg";
export { ForwardRef as ReactComponent };